import { Button } from "@babackapp/ui/components/button";
import { Input, InputProps } from "@babackapp/ui/components/input";
import { EyeClosedIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import FormInputContainer from "./form-input-container";

type FormInputProps = InputProps & {
  label: string;
  description?: string;
};

export default function FormPasswordInput({
  label,
  description,
  ...props
}: FormInputProps) {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => setVisible((v) => !v);

  return (
    <FormInputContainer label={label} description={description}>
      <div className="relative">
        <Input
          className="pr-[32px]"
          {...props}
          type={visible ? "text" : "password"}
        />
        <Button
          type="button"
          variant="ghost"
          className="p-0 absolute right-1 top-1 b-1 w-[32px] h-[32px] flex items-center justify-center"
          onClick={toggleVisibility}
        >
          {visible ? <EyeOpenIcon /> : <EyeClosedIcon />}
        </Button>
      </div>
    </FormInputContainer>
  );
}
